import React, { Component } from 'react';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import { hoverHelpers } from 'shared-helpers';
import { sharedLoggerApi } from 'shared-helpers';

// api
import startupApi from '/src/apis/startupApi';
import searchApi from '/src/apis/searchApi';

// constants
import { STARTUP_BENCHMARKING_HEADERS, NO_SIMILAR_STARTUPS } from '/src/lib/constants';
import { MAGNITT_ACCESS_ROLES } from '/src/lib/constants/userRoles';
import { STARTUP_ADDED, STARTUP_EXISTS } from '/src/lib/messages'

// helpers
import { amountFormatter, getItemWebUrl } from "/src/lib/helpers";
import AmplitudeHelperClass from '/src/lib/amplitudeHelper';

// components
import toast from '/src/components/Reusable/toast';
import ErrorBoundary from '/src/components/ErrorBoundary';
import { getStartupInvestors } from '../Helpers/startupHelper';

const amplitudeHelper = new AmplitudeHelperClass();
const loggerApi = sharedLoggerApi;


export default class DynamicStartupBenchmarking extends Component {

    constructor(props) {
        super(props);
        this.id = props.id;
        this.state = {
            hasDirAccess: false,
            data: props.data,
            currentStartup: (props.startupName) ? props.startupName : ""
        }

        this.amplitudeTrack = this.amplitudeTrack.bind(this);
    }

    componentDidMount() {
        const { user } = this.props;

        if (user && (user.roles.includes(MAGNITT_ACCESS_ROLES.directory_access) || user.roles.includes(MAGNITT_ACCESS_ROLES.limited_directory_access))) {
            this.setState({ hasDirAccess: true })
        }
    }

    amplitudeTrack(type) {
        // add amplitude tracking for startup benchmarking
        amplitudeHelper.trackEvent(`Clicked ${type} in Benchmarking`, {
            startup: this.state.currentStartup
        });
    }

    handleAddNewStartup = (idFetch, searchMsg) => {
        let { data } = this.state;

        // Check for duplicate entry
        if (data.find(startup => startup.id == idFetch)) {
            toast.error(STARTUP_EXISTS, "startup-exists");
            return;
        } else {
            amplitudeHelper.trackEvent(searchMsg);

            startupApi.getAdditionalStartupBenchmarking(this.id, idFetch).then(
                async response => {

                    const startupData = await getStartupInvestors(response);

                    data.push(startupData[0]);
                    this.setState({ data });
                    toast.success(STARTUP_ADDED, "startup-added");
                }
            );
        }
    }

    handleRemoveStartup = (index) => {
        let { data } = this.state;

        data.splice(index, 1);
        this.setState({ data });
    }

    renderBenchmarkingTable = () => {
        let { data } = this.state;
        let sections = [], headers = [];

        // Render header sections
        STARTUP_BENCHMARKING_HEADERS.forEach((item) => {
            sections.push(
                <div className="section-div table-header" key={item.key}>{item.label}</div>
            )
        });

        // Render content sections
        data.forEach((item, index) => {
            sections.push(
                <>
                    <CompanyProfile data={item} index={index} key={`company-profile-` + index} amplitudeTrack={this.amplitudeTrack} handleRemoveStartup={this.handleRemoveStartup} />
                    <LatestFunding data={item.latest_funding} key={`latest-funding-` + index} />
                    <InvestorsData data={item.investors_data} hasDirAccess={this.state.hasDirAccess} key={`investors-data-` + index} amplitudeTrack={this.amplitudeTrack} />
                    <ExitData data={item.exit_data} hasDirAccess={this.state.hasDirAccess} key={`exit-data` + index} amplitudeTrack={this.amplitudeTrack} />
                    <TeamData data={item} key={`team-data` + index} amplitudeTrack={this.amplitudeTrack} />
                    <FounderData data={item.founder_data} key={`founder-data` + index} amplitudeTrack={this.amplitudeTrack} />
                </>
            );
        })
        return sections;
    }

    render() {
        let { currentStartup, data } = this.state;
        const { sectionRef } = this.props;

        const fallbackErrorMessage = (
            <div className='errorFallbackMessage'>

                <h3>Something Went Wrong</h3>
                <p>
                    Sorry, something went wrong. Please try <a
                        href="/contactus">contacting us</a> for help
                </p>
            </div>
        )

        return (
            <div className="block team startup-benchmarking  profile-section-box" ref={sectionRef} id="section-benchmarking">
                <div className="title">
                    <h2 className="profile-section-heading">Startup Benchmarking Tool</h2>
                    {currentStartup &&
                        <div className="sub-title">See how <b>{currentStartup}</b> compares to similar startups <span className="sm-screen-message">(This feature is optimized for desktop view)</span></div>
                    }
                </div>
                <ErrorBoundary
                    fallbackErrorMessage={fallbackErrorMessage}
                >
                    <div className="widget-search">
                        <StartupSearch handleAddNewStartup={this.handleAddNewStartup} />
                    </div>

                    <div className="benchmarking-table mb-0">

                        {data.length >= 1 &&
                            <div key={data.id + "-" + data.code} className="css-grid-table mb-0">
                                <div className="css-grid-table-body mb-0" key={data.id + "-" + data.code}>
                                    {this.renderBenchmarkingTable()}
                                </div>
                            </div>
                        }

                        {data.length < 1 &&
                            <div className="not-applicable pt-5 pb-3 text-center">{NO_SIMILAR_STARTUPS}</div>
                        }

                    </div>
                </ErrorBoundary>
            </div>
        )
    }
}

class CompanyProfile extends Component {
    render() {
        const { data, index, handleRemoveStartup, amplitudeTrack } = this.props;
        const startupURL = '/' + getItemWebUrl("startups", data.id, data.code);
        let image;
        let website = data.website ? data.website.replace(/^(?:https?:\/\/)?(?:http?:\/\/)?(?:www\.)?/i, "").split('/')[0] : null; // format website display

        if (data.logo) {
            image = (index == 0) ?
                <img className="startup-logo" src={encodeURI(data.logo)} />
                :
                <a href={startupURL} target="_blank" rel="noopener noreferrer" onClick={() => amplitudeTrack('startup')}>
                    <img className="startup-logo" src={encodeURI(data.logo)} />
                </a>;
        } else {
            image = (index == 0) ?
                <div className="startup-logo"><h2>{data.name.substr(0, 1)}</h2></div>
                :
                <a href={startupURL} target="_blank" rel="noopener noreferrer" onClick={() => amplitudeTrack('startup')}>
                    <span className="startup-logo d-block"><h2>{data.name.substr(0, 1)}</h2></span>
                </a>
        }

        return (
            <div className="section-div company-profile">
                <div className="sm-screen-header">Company Profile</div>
                <div className="sm-screen-seperator m-0">
                    <div className="seperator-left m-0">
                        {image}
                        {index !== 0 &&
                            <i className="fa fa-times close-button" onClick={() => handleRemoveStartup(index)}></i>
                        }
                    </div>
                    <div className="m-0">
                        {data.primary_industry && <div className="industry-tag mb-2 m-0"><p>{data.primary_industry}</p></div>}
                        {data.name &&
                            <>
                                {(index == 0) ?
                                    <div className="startup-name sm-screen-top-padding mb-2 m-0">{data.name}</div>
                                    :
                                    <a href={startupURL} target="_blank" rel="noopener noreferrer" onClick={() => amplitudeTrack('startup')}>
                                        <div className="startup-name sm-screen-top-padding mb-2 m-0">{data.name}</div>
                                    </a>
                                }
                            </>
                        }
                        {data.location && <div className="startup-location m-0">{data.location}</div>}
                        {data.date_founded &&
                            <div className="startup-date m-0">
                                Founded {moment(data.date_founded).format('MMM YYYY')}
                            </div>
                        }
                        {data.primary_industry && <div className="sm-industry-tag m-0"><p>{data.primary_industry}</p></div>}
                        {data.website &&
                            <a className="startup-website" href={data.website} target="_blank" rel="noopener noreferrer" onClick={() => amplitudeTrack('startup website')}>
                                <i className="fas fa-link"></i>
                                {website}
                            </a>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

class LatestFunding extends Component {
    render() {
        const { data } = this.props;
        let valuation = "N/A";

        if (!isEmpty(data) && !isEmpty(data.valuation)) {
            if (data.valuation.max && data.valuation.min)
                valuation = `${amountFormatter(data.valuation.min)} - ${amountFormatter(data.valuation.max)}`;
            else if (data.valuation.max)
                valuation = `0 - ${amountFormatter(data.valuation.max)}`;
        }

        return (
            <>
                {!isEmpty(data) ?
                    <div className="section-div latest-funding">
                        <div className="sm-screen-header">Latest Funding</div>
                        <div className="sm-screen-seperator-left">
                            {data.stage && <div className="funding-stage sm-screen-top-padding m-0">{data.stage}</div>}
                            {data.date_raised &&
                                <div className="funding-date m-0">
                                    {moment(data.date_raised).format('MMM YYYY')}
                                    {data.amount ?
                                        <> | {amountFormatter(data.amount)}</>
                                        :
                                        <> | Undisclosed</>
                                    }
                                </div>
                            }
                        </div>
                        <div className="sm-screen-seperator-right">
                            {!isEmpty(data.valuation) ?
                                <>
                                    <div className="funding-valuation-title sm-screen-top-padding m-0">{data.valuation.is_estimate ? 'Est. Valuation' : 'Valuation'}</div>
                                    <div className="funding-valuation m-0">{valuation}</div>
                                </>
                                :
                                <div className="align-top">
                                    <div className="not-applicable m-0">N/A</div>
                                </div>
                            }
                        </div>
                    </div>
                    :
                    <div className="section-div latest-funding align-top">
                        <div className="sm-screen-header">Latest Funding</div>
                        <div className="not-applicable sm-screen-top-padding sm-screen-left-padding m-0">N/A</div>
                    </div>
                }
            </>
        );
    }
}

class InvestorsData extends Component {
    render() {
        const { data, hasDirAccess, amplitudeTrack } = this.props;
        let investors = [];

        if (!isEmpty(data)) {
            data.forEach((investor, index) => {
                // ignore invalid values
                if (!investor?.name) {
                    return;
                }

                investor.type = investor.type.toLowerCase();
                investors.push(
                    <span key={`investor-` + investor.id + `-` + index}>
                        {(investor.type == "USER") ?
                            <span className="investors-name">{index != 0 && ', '}{investor.name.trim()}</span>
                            :
                            <a target="_blank" rel="noopener noreferrer" href={`/${investor.type}s/` + investor.code + `-` + investor.id} onClick={() => amplitudeTrack('investor')}>
                                {index != 0 && ', '}
                                <span
                                    className="investors-name investors-name-entity"
                                    onMouseEnter={(event) => hoverHelpers.handleEntityHover(investor, event, hasDirAccess)}
                                    onMouseLeave={() => hoverHelpers.handleMouseOut()}>
                                    {investor.name.trim()}
                                </span>
                            </a>
                        }
                    </span>
                )
            })
        }

        return (
            <div className="section-div investors-data align-top">
                <div className="sm-screen-header">Investor(s)</div>
                {!isEmpty(data) ?
                    <div className="sm-screen-top-padding sm-screen-left-padding m-0">{investors}</div>
                    :
                    <div className="sm-screen-top-padding sm-screen-left-padding not-applicable m-0">N/A</div>
                }
            </div>
        );
    }
}

class ExitData extends Component {
    render() {
        const { data, hasDirAccess, amplitudeTrack } = this.props;
        let acquirers = [];

        if (!isEmpty(data)) {
            data.forEach((acquirer, index) => {
                // ignore invalid values
                if (!acquirer.name) {
                    return;
                }

                acquirer.type = acquirer.entity_type.toLowerCase();
                acquirer.id = acquirer.entity_id;
                acquirers.push(
                    <span key={`acquirer-` + acquirer.entity_id + `-` + index}>
                        {(acquirer.entity_type == "USER") ?
                            <span> {index != 0 && ', '}{acquirer.name}</span>
                            :
                            <a target="_blank" rel="noopener noreferrer" href={`/${acquirer.type}s/` + acquirer.code + `-` + acquirer.entity_id} onClick={() => amplitudeTrack('acquirer')}>
                                <span
                                    onMouseEnter={(event) => hoverHelpers.handleEntityHover(acquirer, event, hasDirAccess)}
                                    onMouseLeave={() => hoverHelpers.handleMouseOut()}>
                                    {index != 0 && ', '}
                                    {acquirer.name}
                                </span>
                            </a>
                        }
                    </span>
                )
            })
        }

        return (
            <div className="section-div exit-data align-top">
                <div className="sm-screen-header">Exit</div>
                {!isEmpty(data) ?
                    <>
                        <div className="sm-screen-seperator-left">
                            <div className="exit-title sm-screen-top-padding m-0">Acquired by</div>
                        </div>
                        <div className="sm-screen-seperator-right">
                            <div className="exit-acquirers sm-screen-top-padding m-0">{acquirers}</div>
                            {data[0].date_raised && <div className="exit-date m-0">{moment(data[0].date_raised).format('MMM YYYY')}</div>}
                        </div>
                    </>
                    :
                    <div className="not-applicable sm-screen-top-padding sm-screen-left-padding m-0">N/A</div>
                }
            </div>
        );
    }
}

class TeamData extends Component {
    render() {
        const { data, amplitudeTrack } = this.props;

        let teamSize = "N/A";
        if (data.min_num_emp && data.max_num_emp) {
            teamSize = `${data.min_num_emp} - ${data.max_num_emp}`;
        } else if (data.min_num_emp && data.max_num_emp == 0) {
            teamSize = `${data.min_num_emp}+`;
        }

        let team = [];
        if (!isEmpty(data.team_data)) {
            data.team_data.forEach((member, i) => {
                if (member.people_id) {
                    let image;

                    if (member.logo) {
                        image = <img className="team-profile-img" src={encodeURI(member.logo)} data-toggle="tooltip" data-original-title={`${member.f_name} ${member.l_name}`} key={`team-img-` + member.people_id} />;
                    } else {
                        image = <span className="team-profile-img" data-toggle="tooltip" data-original-title={`${member.f_name} ${member.l_name}`} key={`team-img-` + member.people_id}>
                            <p>{member.f_name.substr(0, 1)}{member.l_name.substr(0, 1)}</p>
                        </span>
                    }

                    team.push(
                        <span key={`team-` + member.people_id + `-` + i}>
                            <span>{image}</span>
                        </span>
                    )
                }
            })
        }

        return (
            <div className="section-div team-data align-top">
                <div className="sm-screen-header">Team Size and Org</div>
                {(isEmpty(team) && teamSize == "N/A") ?
                    <div className="not-applicable sm-screen-top-padding sm-screen-left-padding m-0">N/A</div>
                    :
                    <>
                        <div className="sm-screen-seperator-left">
                            <div className="team-size sm-screen-top-padding m-0">
                                <i className="fas fa-users"></i> {teamSize}
                            </div>
                        </div>
                        <div className="sm-screen-seperator-right">
                            <div className="team-members sm-screen-top-padding m-0">{team}</div>
                        </div>
                    </>
                }
            </div>
        );
    }
}

class FounderData extends Component {
    render() {
        const { data, amplitudeTrack } = this.props;
        let founders = [];

        if (!isEmpty(data)) {
            data.forEach((founder, i) => {
                let image;

                if (founder.profile_pic) {
                    image = <img className="founder-profile-img" src={encodeURI(founder.profile_pic)} key={`founder-img-` + founder.people_id} />;
                } else {
                    image = <span className="founder-profile-img" key={`founder-img-` + founder.people_id}><p>{founder.first_name.substr(0, 1)}{founder.last_name.substr(0, 1)}</p></span>
                }

                founders.push(
                    <div key={`founder-` + founder.people_id + `-` + i} className="founder-items sm-screen-top-padding sm-screen-left-padding m-0 d-flex">
                        <span className="mr-2">{image}</span>
                        <div className="m-0">
                            <div className="founder-name m-0">{founder.first_name} {founder.last_name}</div>
                            <div className="founder-role m-0">{founder.role_name}</div>
                        </div>
                    </div>
                )
            })
        }

        return (
            <div className="section-div founder-data align-top">
                <div className="sm-screen-header">Founders</div>
                {!isEmpty(data) ?
                    <div className="founder-info m-0">{founders}</div>
                    :
                    <div className="not-applicable sm-screen-top-padding sm-screen-left-padding m-0">N/A</div>
                }
            </div>
        );
    }
}

class StartupSearch extends Component {

    constructor(props) {
        super(props)
        this.state = {
            searchWord: '',
            searchResults: [],
        }
    }

    componentDidMount() {
        window.addEventListener('click', this.handleCloseSearch)
    }

    componentWillUnmount() {
        window.removeEventListener('click', this.handleCloseSearch)
    }

    handleSearch = (event) => {
        const value = event.target.value;

        if (value === '') {
            this.setState({ searchResults: [] })
        } else if (value.length > 2) {
            const encodedValue = encodeURIComponent(value);

            searchApi.startupSearch(encodedValue).then(({ searchResults }) => {
                this.setState({ searchResults });
            }).catch(err => {
                let user_id = this.props.user ? this.props.user.user_id : '';
                loggerApi.logError(user_id, "DynamicBenchmarkingStartupAdd", err)
            })

            amplitudeHelper.trackEvent("searched startup in startup benchmarking tool");
        }

        this.setState({ searchWord: value })
    }

    handleCloseSearch = () => {
        if (this.state.searchResults.length > 0) {
            this.setState({
                searchResults: [],
                searchWord: ''
            })
        }
    }

    render() {
        return (
            <form className="form-inline header-search-wrapper header-box" onSubmit={(e) => e.preventDefault()}>
                <input autoComplete="off" value={this.state.searchWord} onChange={this.handleSearch} placeholder="Add startups to compare" />
                <i className="fas fa-search header-search" aria-hidden="true"></i>
                {this.state.searchResults.length > 0 &&
                    <div className="header-search-dropdown header-box">
                        {this.state.searchResults.map((item, i) => {
                            return <StartupResults data={item} key={i} handleAddNewStartup={this.props.handleAddNewStartup} />
                        })}
                    </div>
                }
            </form>
        )
    }
}

class StartupResults extends Component {
    render() {
        let { data } = this.props;
        let image;

        if (data.image) {
            image = (<div className="header-logo" style={{ backgroundImage: `url('${encodeURI(data.image)}')`, backgroundSize: 'cover !important' }}></div>);
        } else if (data.logo_path) {
            image = (<div className="header-logo" style={{ backgroundImage: `url('${encodeURI(data.logo_path)}')`, backgroundSize: 'cover !important' }}></div>);
        } else {
            const title = data.title ? data.title : data.name;
            image = (<div className="header-logo"><h2>{title.substr(0, 1)}</h2></div>);
        }

        const searchMsg = "Dynamic Benchmarking tool startup search - clicked result";
        const industry = data.industry_name;

        return (
            <div onClick={event => { this.props.handleAddNewStartup(data.id, searchMsg) }} className="startup-search-results">
                {image}
                <div className="m-0 ml-2">
                    <h2 style={{ textTransform: 'capitalize', marginTop: '5px' }}>{data.title ? data.title : data.name}</h2>
                    <div style={{ color: '#5D656D', fontSize: 13, lineHeight: '17px', margin: '5px 0' }}>
                        {industry ? industry : <>&nbsp;</>} {/* add spacing if value is not present, to avoid breaking layout*/}
                    </div>
                </div>
            </div>
        )
    }
}
